export const CHAIN_LOGO_URL =
  "https://groceries-whitelabel.ifood.com.br/chain/logos";
export const CHAIN_BANNER_URL =
  "https://groceries-whitelabel.ifood.com.br/chain/banners";
export const MARCHANT_BANNER_URL =
  "https://groceries-whitelabel.ifood.com.br/banners";
